import type { Lang } from '../types/funnel';
import { en, type StringKey } from './strings/en';
import { es } from './strings/es';

export type { StringKey };

export const strings: Record<Lang, Record<StringKey, string>> = { en, es };

export function translate(lang: Lang, key: StringKey, vars?: Record<string, string | number>): string {
  let s = strings[lang][key] ?? strings.en[key] ?? key;
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.replace(`{${k}}`, String(v));
  return s;
}

export function isStringKey(k: string): k is StringKey {
  return k in en;
}
